import { useFormContext } from "react-hook-form";

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

import { type FormControlProps } from "./types";

export const TextFormControl = ({ field, name }: FormControlProps) => {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={(context) => (
        <FormItem>
          <FormLabel>{field.title}</FormLabel>
          <FormControl>
            <Input
              placeholder={field.title}
              type="text"
              minLength={field.minLength ?? undefined}
              maxLength={field.maxLength ?? undefined}
              inputMode={field.client_type === "numeric" ? "numeric" : "text"}
              {...context.field}
            />
          </FormControl>
          {field.description && (
            <FormDescription>{field.description}</FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
